import React from 'react';
import useDeal from 'hooks/useDeal';
import { Button } from 'components/ui/button';
import { useTranslation } from 'react-i18next';

export default function OrderDealButton({ orgId }: { orgId?: string }) {
  const { t } = useTranslation();
  const { deal } = useDeal(orgId);
  console.log({ deal, orgId });

  if (!deal) return null;
  return (
    <Button
      variant={'ghost'}
      className="justify-start"
      onClick={() => window.open(`/deal/${deal?.id}`)}
    >
      {t('orders.deal')}
    </Button>
  );
}
